export function smsCompatibleSharedKeys (urls = []) {
  const SMS_COMPATITIABLE_TYPES = ['multiple_choice_polls', 'free_text_polls']
  return urls
    .filter(url => SMS_COMPATITIABLE_TYPES.includes(url.path().split('/')[1]))
    .map(url => url.path().split('/')[2])
}
